import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AlertController,
  NavController,
  ToastController,
} from '@ionic/angular';

import { Booking } from '../../models/booking/booking.model';
import { Service } from '../../models/service/service.model';
import { BookingService } from '../../services/booking.service';
import { IBookingFormCallBackData } from '../../bookings/booking-form/booking-form-summary/booking-form-summary.page';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import {
  ActivatedRoute,
  Router,
  RouterEvent,
  NavigationExtras,
} from '@angular/router';
import { NavigationStateService } from '../../services/navigation-state.service';
@Component({
  selector: 'app-waitlist-form',
  templateUrl: './waitlist-form.page.html',
  styleUrls: ['./waitlist-form.page.scss'],
})
export class WaitlistFormPage implements OnInit, OnDestroy {
  public booking: Booking;

  public savingInProgress: boolean;

  public bookingFormPromise: Function;

  public navigationStateSubscription;

  constructor(
    private navCtrl: NavController,
    //private navParams: NavParams,
    private bookingService: BookingService,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private router: Router,
    private route: ActivatedRoute,
    private navigationStateService: NavigationStateService
  ) {
    this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
      this.booking = state.booking;
    });
  }

  public ngOnInit() {
    this.savingInProgress = false;
  }

  public ngOnDestroy() {
    this.navigationStateSubscription.unsubscribe();
  }

  public onClientNameTap(booking: Booking) {
    this.navigationStateService.setState({
      modal: true,
      clientID: booking.getClient().id,
    });
    this.router.navigate(['/clients/client-detail']);
  }

  public onClientNotesChange($event) {
    if (this.booking.getServices().count() > 0) {
      const service: Service = this.booking
        .getServices()
        .get(0)
        .setClientNotes($event.target.value);
      this.booking = this.booking.setServices(List.of(service));
    }
  }

  public onBookingSave() {
    // save booking info
    this.savingInProgress = true;
    this.bookingService.saveBooking(this.booking).subscribe({
      next: async (booking: Booking) => {
        const data: IBookingFormCallBackData = {
          booking: booking,
          action: 'save',
        };

        this.savingInProgress = false;
        this.router.navigateByUrl('waitlist');
        const toast = await this.toastCtrl.create({
          message: `Wait List Booking has been created`,
          duration: 3000,
        });
        toast.present();
      },
      error: async (error) => {
        this.savingInProgress = false;
        const alert = await this.alertCtrl.create(
          Utilities.getDefaultErrorMessageConfig()
        );
        alert.present();
      },
    });
  }

  public onBookingCancel() {
    this.router.navigateByUrl('waitlist');
  }
}
